export const PropertiesApiPath = '/api/portal/properties';
